import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  CardActionArea,
} from "@mui/material";
import { motion } from "framer-motion";

const MotionCard = motion(Card);

export default function TikTokCard({ title, image, tiktokUrl, sxx }) {
  return (
    <MotionCard
      elevation={4}
      whileHover={{ scale: 1.03 }}
      whileTap={{ scale: 0.98 }}
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      sx={{ ...sxx }}
    >
      <CardActionArea
        onClick={() => window.open(tiktokUrl, "_blank")}
      >
        <CardMedia
          component="img"
          image={image}
          height="240"
          sx={{ objectFit: "cover" }}
          alt={title}
        />
        <CardContent
          sx={{
            p: 0,
            px: 1,
            color: "#5e35b1",
            backgroundColor: "#f5f0ff",
            height: "auto",
          }}
        >
          <Typography variant="subtitle1" fontWeight={600} p={0}>
            {title}
          </Typography>
        </CardContent>
      </CardActionArea>
    </MotionCard>
  );
}
